<template>

    <div class="c-alerts">
        <alerts-item
            v-for="alert in alerts"
            :key="alert.id"
            :alert="alert">
        </alerts-item>
    </div>

</template>


<script>

import {mapGetters} from 'vuex'
import AlertsItem from './AlertsItem'

export default {

    name: 'TheAlerts',

    computed: {
        ...mapGetters(['alerts'])
    },

    components: {
        AlertsItem
    }

}

</script>


<style lang="scss">

@import '~Style/_utils.scss';

.c-alerts {
    position: fixed;
    bottom: 0;
    right: 0;
    padding: 2.5rem 2.5rem 2rem 2.5rem;
    width: 445px;
    z-index: 11;
    max-height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    pointer-events: none;

    @include bp($screen-lg) {
        bottom: 50px;
    }
    @include bp(425px) {
        padding: 1.4rem;
        width: 100%;
    }
}

</style>
